import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const ERFList = lazy(() =>
    import(/* webpackChunkName: "ERFLIST" */ './ERFList').then( async module => {
        // wait for fetching userinfo before rendering
        await checkAuth();
        // Only show My Loan List page if user loggedin is authenticated
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            // Register list reducer together with ERF List Route
            store.injectReducer('hrErfList', reducer.listReducer);
            return module;
        }
    })
);

const ERFAdd = lazy(() =>
    import(/* webpackChunkName: "ERFADD" */ './ERFAdd').then(async module => {
        // wait for fetching userinfo before rendering
        await checkAuth();
        // Only show My Loan List page if user loggedin is authenticated
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            // Register list reducer together with ERF ADD Route
            store.injectReducer('hrErfAdd', reducer.addReducer);
            return module;
        }
    })
);

const ERFDetail = lazy(() =>
    import(/* webpackChunkName: "memberPafDetail" */ './ERFDetail').then(async module => {
        // wait for fetching userinfo before rendering
        await checkAuth();
        // Only show Member PAF Detail page if user loggedin is authenticated
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
           // Register add reducer together with PAF Add Route
            store.injectReducer('hrErfDetail', reducer.detailReducer);
            return module;
        }
    })
);

const ERFRoutes = [
    {
        label: 'Employee Request Form',
        path: '/HRAutomation/ERF',
        menuName: 'EmployeeRequestForm',
        component: ERFList,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
    {
        label: 'Employee Request Form',
        path: '/HRAutomation/ERF/Add',
        menuName: 'EmployeeRequestForm',
        component: ERFAdd,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
    {
        label: 'Employee Request Form',
        path: '/HRAutomation/ERF' + '/:documentid' + '/:id' + '/:mode',
        menuName: 'EmployeeRequestForm',
        component: ERFDetail,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    }
]

export default ERFRoutes;